import { initPosthog } from "@/lib/analytics";
import app from "@/app";

initPosthog();
app("#app");
